"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPgCompanyLabel = formatPgCompanyLabel;
exports.pgCompanyNameOf = pgCompanyNameOf;
/** PG 업체 표기 `NN. 이름` — 서버 응답(`label`·`pgCompanyLabel`)과 화면이 같은 함수를 쓴다 */
function formatPgCompanyLabel(seq, name) {
    return `${String(seq).padStart(2, '0')}. ${name}`;
}
/**
 * `NN. 이름` 표기에서 이름만 — **목록 열**은 번호 없이 이름만 보여준다 (2026-09-23 소장 통화:
 * "03. 이름"처럼 콤보 값이 그대로 열에 들어와 번호가 딸려 나옴). 선택지(콤보)는 번호를 그대로 둔다.
 * `formatPgCompanyLabel`의 역함수라 형식이 바뀌면 함께 바꾼다.
 */
function pgCompanyNameOf(label) {
    return label.replace(/^\d{2}\. /, '');
}
